export function shouldShowCancellationsOverviewSaveHelper(
  hasReliabilityChanges: boolean,
  canSubmit: boolean
): boolean {
  return Boolean(hasReliabilityChanges && !canSubmit);
}
